var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"box",attrs:{"max-width":"500"}},[_c('v-img',{attrs:{"height":"175","src":_vm.picUri}}),_c('div',{staticClass:"px-4 py-3"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }